<template>
  <layout-main>
    <div class="cards-container">
      <div
        class="card-wrapper"
        v-for="service in services"
        :key="service.serviceCode"
        @click="openApp(service)"
        :style="{cursor: service.available ? 'pointer' : 'inherit', opacity: service.available ? 1 : 0.5}"
      >
        <md-card
          :md-with-hover="service.available"
        >
          <md-card-header>
            <md-badge class="md-square" md-content="未契約" v-if="!service.available" />
            {{service.serviceName}}
            </md-card-header>
          <md-card-media>
            <img :src="service.imageUrl">
          </md-card-media>
          <md-card-content>
            {{ service.description }}
          </md-card-content>
        </md-card>
      </div>
    </div>
  </layout-main>
</template>

<script>
import LayoutMain from '@/components/layout/LayoutMain'
import { getCompanyCode, getLoginId } from '@/util/token'

export default {
  components: { LayoutMain },
  data() {
    return {
      services: [],
    }
  },
  methods: {
    openApp(service) {
      if (service.available) {
        window.open(service.url)
      }
    },
  },
  async mounted() {
    const companyCode = getCompanyCode()
    const loginId = getLoginId()

    const allServices = await this.$service.getServices()

    const account = await this.$account.getAccount(companyCode, loginId)
    const userServices = account.services

    this.services = allServices.map(s => ({
      ...s,
      available: userServices.includes(s.serviceCode) || s.dataType === null,
    }))
  },
}
</script>

<style lang="scss" scoped>
.cards-container {
  display: flex;
  flex-wrap: wrap;
  padding: 64px;
}
.card-wrapper {
  flex: 0 0 400px;
  cursor: pointer;
  margin-left: 32px;
  margin-right: 32px;
}
</style>
